"use client"

import { createRoute } from "@tanstack/react-router"

import { DesignSystemPage } from "@/components/design-system/design-system-page"
import MainAppRoute from "@/rootRoutes/MainApp"

const DesignSystemRoute = createRoute({
  getParentRoute: () => MainAppRoute,
  path: "/ds",
  component: DesignSystemPage,
})

export default DesignSystemRoute
